<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/commodityFlowStateList' }">流向状态</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <draggableDetail :draggable="{ data_name: 'commodity_flow_state' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="in_array(item.prop, ['account', 'product', 'partner', 'ppa_code'])"
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>

                <el-collapse-item disabled title="流向列表" name="2">
                    <vFlowSourceListsComponent :postList="flow_params" v-if="flag"></vFlowSourceListsComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vFlowSourceListsComponent from '../../listComponent/basicdata/flowSourceLists/flowSourceListsComponent.vue';
export default {
    inject: ['reload'],
    name: 'commodityFlowStateDetail',
    components: {
        vFlowSourceListsComponent,
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            headerTitle: '流向状态详情',
            flag: false,
            flow_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            this.flow_params.params = {
                ppa_code: this.data.ppa_code,
                month: this.data.month
            };
            this.flow_params.source_account_rid = true;
            this.flow_params.source_file = true;
            this.flow_params.demander_rid = true;
            this.flow_params.supplier_rid = true;
            this.flow_params.no_demander = true;
            this.flow_params.no_supplier = true;
            this.flow_params.no_product = true;
            this.flow_params.source_account_code = true;
            this.flow_params.commodity_flow_source_rid = true;
            this.flow_params.rid = true;
            this.flow_params.source_demander = true;
            this.flow_params.sup_supplier_rid = true;
            this.flow_params.insertBtn = true;
            this.flow_params.updateBtn = true;
            this.flow_params.searchBtn = true;
            this.flow_params.resetBtn = true;
            this.flow_params.downFileBtn = true;
            this.flow_params.setBtn = true;

            this.flag = true;
        },
        toDetail(prop) {
            if (prop == 'account' && this.data.account_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.account_rid
                    }
                });
            } else if (prop == 'product' && this.data.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            } else if (prop == 'partner' && this.data.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.partner_rid
                    }
                });
            } else if (prop == 'ppa_code' && this.data.ppa_rid != '') {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: this.data.ppa_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).commodity_flow_state;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .commodityFlowStateDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;

                    this.initSubListParams();
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>